import { motion } from "framer-motion";
import { clipReveal, fadeUp, staggerContainer } from "../../lib/animations";
import SectionLabel from "../ui/SectionLabel";
import FloatingShapes from "../graphics/FloatingShapes";
import BackgroundGradient from "../../components/effects/BackgroundGradient";

interface PageHeroProps {
  label: string;
  title: string;
  titleAccent?: string;
  subtitle?: string;
}

const PageHero = ({ label, title, titleAccent, subtitle }: PageHeroProps) => (
  <section
    className="obsidian-bg-texture"
    style={{
      background: "#050505",
      padding: "160px clamp(20px, 4vw, 48px) 80px",
      position: "relative",
      overflow: "hidden",
    }}
  >
    {/* Ambient background */}
    <BackgroundGradient />
    <FloatingShapes seed={42} count={6} />

    <motion.div
      variants={staggerContainer}
      initial="hidden"
      animate="visible"
      style={{ maxWidth: 1200, margin: "0 auto", position: "relative", zIndex: 2 }}
    >
      <motion.div variants={fadeUp}>
        <SectionLabel text={label} />
      </motion.div>
      <motion.h1 variants={clipReveal} style={{ marginTop: 28, marginBottom: 28 }}>
        <span
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontWeight: 300,
            fontSize: "clamp(44px, 6.4vw, 78px)",
            color: "#F8F4EC",
            letterSpacing: "-0.02em",
            lineHeight: 1,
            display: "block",
          }}
        >
          {title}
        </span>
        {titleAccent && (
          <span
            style={{
              fontFamily: "'Bebas Neue', sans-serif",
              fontWeight: 400,
              fontSize: "clamp(46px, 6.8vw, 84px)",
              color: "#D4A843",
              lineHeight: 1,
              letterSpacing: "0.01em",
              display: "block",
              marginTop: 4,
            }}
          >
            {titleAccent}
          </span>
        )}
      </motion.h1>
      {subtitle && (
        <motion.p
          variants={fadeUp}
          style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 17,
            color: "#8B8378",
            lineHeight: 1.7,
            maxWidth: 560,
            fontWeight: 300,
          }}
        >
          {subtitle}
        </motion.p>
      )}
      <motion.div
        variants={fadeUp}
        style={{ width: 48, height: 0.5, background: "#D4A843", marginTop: 32 }}
      />
    </motion.div>

    {/* Decorative vertical line */}
    <div
      style={{
        position: "absolute",
        right: "4vw",
        bottom: 30,
        width: 1,
        height: 80,
        background: "linear-gradient(to bottom, rgba(212,168,67,0), rgba(212,168,67,0.7), rgba(212,168,67,0))",
        zIndex: 1,
      }}
    />
  </section>
);

export default PageHero;
